module.exports = __webpack_public_path__ + "static/media/trump.7e397d5a.jpg";